export enum FitzpatrickType {
  Type0 = '0',
  Type1 = '1',
  Type2 = '2',
  Type3 = '3',
  Type4 = '4',
  Type5 = '5',
  Type6 = '6',
}

export const FITZPATRICK_LABELS: Record<FitzpatrickType, string> = {
  [FitzpatrickType.Type0]: '',
  [FitzpatrickType.Type1]: 'Type 1 - Pale White Skin',
  [FitzpatrickType.Type2]: 'Type 2 - White or Fair Skin',
  [FitzpatrickType.Type3]: 'Type 3 - Cream White or Fair Skin',
  [FitzpatrickType.Type4]: 'Type 4 - Light Brown Skin',
  [FitzpatrickType.Type5]: 'Type 5 - Dark Brown Skin',
  [FitzpatrickType.Type6]: 'Type 6 - Deeply Pigmented Dark Brown Skin',
};

export const FITZPATRICK_OPTIONS = Object.entries(FITZPATRICK_LABELS).map(([value, text]) => ({
  value,
  text,
}));
